import { renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-30923926")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("section", {
    style: _ctx.containerStyle,
    class: "scroll-container"
  }, [
    _createVNode("div", {
      class: ["scrollContainer", ['scroll-type-'+_ctx.scrollType]],
      style: _ctx.scrollContainer,
      ref: "scroll"
    }, [
      _createVNode("section", {
        class: "scrollContainerTake",
        ref: "scrollTake",
        style: {height:_ctx.minHeight}
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ], 4)
    ], 6)
  ], 4))
})